@if (!group) {
<div class="cd-dropdown" [ngClass]="[open ? 'open' : '']">
  @if (label) {
  <div>
    <span class="cds-body2 label">{{ label | lang }}</span>
  </div>
  }
  <div (click)="blur()" class="selected-val-box" [ngClass]="[disabled ? 'disable-selected' : '']">
    <mat-form-field style="width: 100%" appearance="fill">
      <input
        #myInput
        [formControl]="valueControl"
        type="text"
        [ngClass]="['selected-input', 'opacity']"
        matInput
        [matAutocomplete]="auto"
        #trigger="matAutocompleteTrigger"
        appCdAutocompletePosition="trigger" />
      <mat-autocomplete #auto="matAutocomplete" class="cd-dropdown-panel" (opened)="onOpened(auto)" (closed)="onClosed()">
        @for (option of toppingList; track option) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <span [ngClass]="['selected-val', showVaule.length > 0 ? '' : 'placeholder']">
      {{ showVaule || (placeholder | lang) }}
    </span>
    <div (click)="myInput.click()" class="mask"></div>
    <cds-icon [ngClass]="['button-down', open ? 'up' : '', disabled ? 'disabled-button-down' : '']" icon="action:button_down"></cds-icon>
  </div>
  <div [ngClass]="['line', open ? 'line-light' : '', disabled ? 'disabled-line' : '']"></div>
</div>
} @if (group) {
<div class="cd-dropdown" [ngClass]="[open ? 'open' : '']">
  @if (label) {
  <div>
    <span class="cds-body2 label">{{ label | lang }}</span>
  </div>
  }
  <div [formGroup]="group" (click)="blur()" class="selected-val-box" [ngClass]="[disabled ? 'disable-selected' : '']">
    <mat-form-field style="width: 100%" appearance="fill">
      <input
        #myInput
        [formControlName]="controlName"
        type="text"
        [ngClass]="['selected-input', 'opacity']"
        matInput
        [matAutocomplete]="auto"
        #trigger="matAutocompleteTrigger"
        appCdAutocompletePosition="trigger" />
      <mat-autocomplete #auto="matAutocomplete" class="cd-dropdown-panel" (opened)="onOpened(auto)" (closed)="onClosed()">
        @for (option of toppingList; track option) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <span [ngClass]="['selected-val', showVaule.length > 0 ? '' : 'placeholder']">
      {{ showVaule || (placeholder | lang) }}
    </span>
    <div (click)="myInput.click()" class="mask"></div>
    <cds-icon [ngClass]="['button-down', open ? 'up' : '', disabled ? 'disabled-button-down' : '']" icon="action:button_down"></cds-icon>
  </div>
  <div [ngClass]="['line', open ? 'line-light' : '', disabled ? 'disabled-line' : '']"></div>
</div>
}
